// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1b991356","726":"3f3bafb2","977":"0296d865"}[chunkId] + ".chunk.js";
};